import { Theme, createStyles, makeStyles } from '@material-ui/core';
import { NonHoverBackground } from 'src/theme/colors';

export const useNotificationBreadcrumbsStyles = makeStyles((theme: Theme) =>
  createStyles({
    breadcrumbs: {
      display: 'flex',
      height: 32,
      borderRadius: 64,
      width: 'fit-content',
      backgroundColor: NonHoverBackground,
      padding: theme.spacing(0, 1.5),
      alignItems: 'center',
    },
  }),
);
